import getConfig from 'next/config';

import { createClient } from '@sravni/ugc/lib/client';

import { isServer } from '../../utils/isServer';

// это нужно что бы когда сервер делает запросы в свою же прокси, запросы не выходили из кубера
const url = isServer
  ? `${process.env.INTERNAL_WEB_PATH}${process.env.API_PATH}`
  : getConfig().publicRuntimeConfig.apiPathUrl;

export const ProxyClient = createClient(url, { sentryErrorTagName: 'news-frontend-proxy' });
